"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminEventJourneyUserDto = exports.AdminEventJourneyStepDto = exports.AdminEventJourneyDto = exports.AdminEventJourneySourceRowDto = exports.AdminEventJourneyTotalsDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const AdminVenueEvent_dto_1 = require("./AdminVenueEvent.dto");
class AdminEventJourneyTotalsDto {}
exports.AdminEventJourneyTotalsDto = AdminEventJourneyTotalsDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "modalShown", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "modalShownUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "cardTaps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "cardTapUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "ctaTaps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "ctaUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "getTicketsTaps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "getTicketsUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Current RSVPs (any source).'
}), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "rsvps", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Held tickets (pending / paid, any source).'
}), __metadata("design:type", Number)], AdminEventJourneyTotalsDto.prototype, "tickets", void 0);
class AdminEventJourneySourceRowDto {}
exports.AdminEventJourneySourceRowDto = AdminEventJourneySourceRowDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  nullable: true,
  description: 'Null: not reported (older app builds).'
}), __metadata("design:type", Object)], AdminEventJourneySourceRowDto.prototype, "source", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneySourceRowDto.prototype, "rsvps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneySourceRowDto.prototype, "getTicketsTaps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventJourneySourceRowDto.prototype, "tickets", void 0);
/** Event-level summary: funnel totals and conversions per source. */
class AdminEventJourneyDto {}
exports.AdminEventJourneyDto = AdminEventJourneyDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventSummaryDto
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventSummaryDto)], AdminEventJourneyDto.prototype, "event", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventVenueDto
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventVenueDto)], AdminEventJourneyDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Partnered hotspots that promoted this event.',
  type: String,
  isArray: true
}), __metadata("design:type", Array)], AdminEventJourneyDto.prototype, "partneredHotspotPublicIds", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminEventJourneyTotalsDto
}), __metadata("design:type", AdminEventJourneyTotalsDto)], AdminEventJourneyDto.prototype, "totals", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminEventJourneySourceRowDto,
  isArray: true
}), __metadata("design:type", Array)], AdminEventJourneyDto.prototype, "bySource", void 0);
class AdminEventJourneyStepDto {}
exports.AdminEventJourneyStepDto = AdminEventJourneyStepDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AdminEventJourneyStepType
}), __metadata("design:type", String)], AdminEventJourneyStepDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  nullable: true
}), __metadata("design:type", Object)], AdminEventJourneyStepDto.prototype, "source", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminEventJourneyStepDto.prototype, "at", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Extra info, e.g. the ticket status.'
}), __metadata("design:type", Object)], AdminEventJourneyStepDto.prototype, "detail", void 0);
/** One user's path to the event, oldest step first. */
class AdminEventJourneyUserDto {}
exports.AdminEventJourneyUserDto = AdminEventJourneyUserDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventUserDto
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventUserDto)], AdminEventJourneyUserDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminEventJourneyUserDto.prototype, "rsvpedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  nullable: true
}), __metadata("design:type", Object)], AdminEventJourneyUserDto.prototype, "rsvpSource", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.TicketStatus,
  nullable: true
}), __metadata("design:type", Object)], AdminEventJourneyUserDto.prototype, "ticketStatus", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  nullable: true
}), __metadata("design:type", Object)], AdminEventJourneyUserDto.prototype, "ticketSource", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminEventJourneyStepDto,
  isArray: true
}), __metadata("design:type", Array)], AdminEventJourneyUserDto.prototype, "steps", void 0);
//# sourceMappingURL=AdminEventJourney.dto.js.map